import styled from 'styled-components';

// Aligns the course details and payment totals
export const SidebySide = styled.div`
  /* border: 2px solid red; */
  display: flex;
  gap: 1rem;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
// Displays info about the course for checkout
export const CourseInfoTable = styled.section`
  /* border: 1px solid blue; */
  display: flex;
  flex-direction: column;
  width: 75%;
  @media screen and (max-width: 768px) {
    gap: ${({ theme }) => theme.spacing.s};
    padding: ${({ theme }) => theme.spacing.s};
    width: 100%;
  }
`;
export const TotalDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${({ theme }) => theme.spacing.m};
  background-color: ${({ theme }) => theme.colors.grey15};
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  border-radius: ${({ theme }) => theme.borderRadius};
  width: 35%;
  height: 35%;
  /* border: 2px solid red; */
  select {
    background-color: ${({ theme }) => theme.colors.grey15};
    border: none;
  }
  select:hover {
    color: ${({ theme }) => theme.colors.orange2};
  }
  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    /* padding: ${({ theme }) => theme.spacing.xs}; */
    /* border-bottom: 1px solid ${({ theme }) => theme.colors.grey1}; */
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
export const PayPalButtonContainer = styled.div`
  /* border: 2px solid blue; */
  width: 80%;
  padding-top: ${({ theme }) => theme.spacing.xl};
  margin: 0 auto;
  @media screen and (max-width: 768px) {
    width: 80%;
  }
  @media screen and (max-width: 468px) {
    width: 100%;
  }
`;
// Form for the billing information
export const BillingInfoForm = styled.form`
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  border-radius: ${({ theme }) => theme.borderRadius};
  h3 {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey};
    text-align: left;
    margin-bottom: ${({ theme }) => theme.spacing.m};
  }
  div {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    margin-top: ${({ theme }) => theme.spacing.xs};
  }
  label {
    font-weight: bold;
    margin-bottom: ${({ theme }) => theme.spacing.xs};
  }
  input,
  select {
    border-radius: ${({ theme }) => theme.borderRadius};
    width: 100%;
    box-sizing: border-box;
    padding: ${({ theme }) => theme.spacing.xs};
    border: 1px solid ${({ theme }) => theme.colors.grey2};
  }
  .side {
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.s};
    /* border: 1px solid orange; */
  }
  .side div {
    min-width: 50%;
    width: 50%;
    max-width: 50%;
    /* border: 2px solid orange; */
  }
  .side input {
    width: 100%;
  }
  .street {
    min-width: 101%;
    /* width: 100%; */
    /* border: 2px solid blue; */
  }
  .street input {
    /* border: 1px solid red; */
    min-width: 100%;
  }
  button {
    margin: 0 auto;
    margin-block: ${({ theme }) => theme.spacing.xl};
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    border: none;
    padding: ${({ theme }) => theme.spacing.m};
    border-radius: ${({ theme }) => theme.borderRadius};
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.primaryDark};
    }
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    button {
      width: 100%;
    }
  }
`;

export const PaymentContainer = styled.section`
  /* border: 2px solid orange; */
  width: 100%;
  text-align: center;
  h3 {
    padding-bottom: ${({ theme }) => theme.spacing.m};
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey};
    text-align: left;
    margin-bottom: ${({ theme }) => theme.spacing.xl};
  }
  div:first-child {
    /* border: 2px solid red; */
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }
  div:last-child {
    /* border: 2px solid blue; */
    width: 70%;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const EachCartItemContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey1};
  /* border: 5px solid orange; */
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* div { */
  /* border: 2px solid red; */
  /* } */
  div:first-child {
    width: 90%;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xs};
    flex-direction: column;
    padding: ${({ theme }) => theme.spacing.s};
  }
  div:last-child {
    width: 10%;
    display: flex;
    align-items: center;
    justify-content: end;
  }
`;

export const PurchaseContainer = styled.section`
  text-align: center;
  h3 {
    margin-bottom: 1rem;
  }
  p {
    margin-bottom: 1rem;
    line-height: 1.5;
    strong {
      color: #000;
    }
  }
  button {
    margin-top: 2rem;
  }
`;
export const TransactionMain = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background: ${({ theme }) => theme.colors.grey15};
  padding: ${({ theme }) => theme.spacing.l};
`;
export const TransactionCompleteSection = styled.section`
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey25};
  /* border-radius: ${({ theme }) => theme.borderRadius}; */
  /* box-shadow: ${({ theme }) => theme.shadows.shadow1}; */
  padding: ${({ theme }) => theme.spacing.l};
  /* margin-bottom: ${({ theme }) => theme.spacing.m}; */
  width: 80%;
  max-width: 600px;

  h2,
  h4 {
    color: ${({ theme }) => theme.colors.grey6};
    font-weight: bold;
    margin-bottom: ${({ theme }) => theme.spacing.s};
  }

  p {
    margin-bottom: ${({ theme }) => theme.spacing.s};
    line-height: 1.6;
    color: ${({ theme }) => theme.colors.grey4};
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;

    li {
      margin-bottom: ${({ theme }) => theme.spacing.xs};
      color: ${({ theme }) => theme.colors.grey4};
    }
  }

  button {
    width: 100%;
    transition: background-color 0.3s ease;
  }
`;
